import React, { useContext } from "react";
export const JsonDataContext = React.createContext(null);
export const useJsonData = () => {
    const context = useContext(JsonDataContext);
    if(context===undefined){
        throw new Error("Context undefined :c");
    }
    return context;
}